const PROSPECT_API = `${process.env.GATSBY_RSC_PROSPECT_API}/invisiblefence/prospect`;

const apiRequest = async (url: string, options: RequestInit = {}) => {
  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      if (response.status === 417) {
        return response;
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`Error during API request to ${url}:`, error);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'api_failure',
      api_url: url,
      http_method: options.method ?? 'GET',
      error_message: error?.message ?? 'unknown',
      page_url: window.location.href,
      page_path: window.location.pathname,
      timestamp: new Date().toISOString(),
    });

    throw new Error(`HTTP error! status: ${error}`);
  }
};

const fetchDealerData = async customer => {
  const url = `${PROSPECT_API}/capture?apiKey=${process.env.GATSBY_RSC_API_KEY}`;
  return apiRequest(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(customer),
  });
};

const getDealerAppointments = async (dealerId, sessionId) => {
  const url = `${PROSPECT_API}/process?apiKey=${process.env.GATSBY_RSC_API_KEY}&sessionId=${sessionId}&dealerId=${dealerId}`;
  return apiRequest(url);
};

const scheduleAppointment = async (selectedSlot, sessionId) => {
  const url = `${PROSPECT_API}/schedule?apiKey=${process.env.GATSBY_RSC_API_KEY}&sessionId=${sessionId}`;
  return apiRequest(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(selectedSlot),
  });
};

const fetchAddressSuggestions = async query => {
  if (!query) return [];

  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
    query
  )}.json?country=US&access_token=${
    process.env.GATSBY_MAPBOX_ACCESS_TOKEN
  }&autocomplete=true&limit=5&types=address`;
  const data = await apiRequest(url);
  return data.features || [];
};

export {
  fetchDealerData,
  getDealerAppointments,
  scheduleAppointment,
  fetchAddressSuggestions,
};
